module.exports = __webpack_public_path__ + "static/img/platform01.e8a38b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform01.png
// module id = 5TPE
// module chunks = 1